/**
 * Whether the SPA offers onboarding or a "not open yet" page (#158).
 *
 * This is the client half only. A closed SPA is a courtesy, not a control:
 * the server-side half is the kill switch, `KARVSTOKK_SPONSORSHIP=halted`,
 * which refuses the sponsored path whatever the page shows.
 *
 * Its own file, without zod, because the SPA checks the gate's answer against
 * it (#161) — the reason `mounts.ts` is apart from `deployment.ts`.
 */
export const ONBOARDING_STATES = ["open", "closed"] as const;

export type OnboardingState = (typeof ONBOARDING_STATES)[number];

export function isOnboardingState(value: unknown): value is OnboardingState {
  return (
    typeof value === "string" &&
    (ONBOARDING_STATES as readonly string[]).includes(value)
  );
}
